import React, { Component } from "react";

import { HomeSlider, HomeTitle } from "../../Components/UI/UI";

import { getWeather } from "../../Utility/Utility";

import MenuHome from "../../Components/Menu/MenuHome";
import Footer from "../../Components/Footer/Footer";

import "./PrivacyPolicy.css";

class PrivacyPolicy extends Component {
  state = {
    telAvivWeather: 0,
    waterTemp: 0,
    jerusalemWeather: 0,
  };

  componentDidMount() {
    getWeather((Weather) => {
      // console.log("Weather", Weather);
      this.setState({
        telAvivWeather: Weather.telAvivWeather,
        waterTemp: Weather.water_temp,
        jerusalemWeather: Weather.jerusalemWeather,
      });
    });
  }

  render() {
    return (
      <div className="page align-left page-TermsOfUse">
        <MenuHome />
        <HomeSlider
          waterTemp={this.state.waterTemp}
          telAvivWeather={this.state.telAvivWeather}
          jerusalemWeather={this.state.jerusalemWeather}
        />

        <div className="container">
          <HomeTitle>PRIVACY POLICY</HomeTitle>

          <p>
            <u>
              <span>Last updated</span>
            </u>
            <span>: March 4, 2020</span>
          </p>

          <h3>
            <span>OUR COMMITMENT TO YOU</span>
            <span>&nbsp;</span>
          </h3>
          <p>
            We, at&nbsp;The Israeli government, the Ministry of Tourism ("
            <strong>us</strong>", "<strong>we</strong>" or the
            <strong>&nbsp;"Ministry</strong>") respect the privacy of our users
            (each, a "<strong>User</strong>" or "<strong>you</strong>") and are
            committed to protect the privacy of Users who access, download,
            install, register, use or engage with our website, our mobile
            application(s), and any other service we provide (the
            <strong>&nbsp;</strong>"<strong>Website</strong>" and "
            <strong>App</strong>" respectively, and collectively the "
            <strong>Service(s)</strong>"). &nbsp;
          </p>
          <p>
            We've prepared this Privacy Policy to outline our practices with
            respect to collecting, using and disclosing your information when
            you use the Services. We encourage you to read this Privacy Policy
            carefully and use it to make informed decisions. By using the
            Services, you agree to the terms of this Privacy Policy and your
            continued use of the Services constitutes your ongoing agreement to
            the Privacy Policy.
          </p>

          <h3>
            <span>CONTENTS</span>
          </h3>
          <p>
            <a href="#Grounds" style={{ color: "black" }}>
              <span>1. </span>GROUNDS FOR DATA COLLECTION
            </a>
            <br />

            <a href="#WhatType" style={{ color: "black" }}>
              <span>2. </span>WHAT TYPE OF DATA WE COLLECT?
            </a>
            <br />

            <a href="#HowDoWeUse" style={{ color: "black" }}>
              <span>3. </span>HOW DO WE USE THE DATA WE COLLECT?
            </a>
            <br />

            <a href="#Tracking" style={{ color: "black" }}>
              <span>4. </span>TRACKING TECHNOLOGIES
            </a>
            <br />

            <a href="#WitWhom" style={{ color: "black" }}>
              <span>5. </span>WITH WHOM DO WE SHARE YOUR PERSONAL DATA?
            </a>
            <br />

            <a href="#HowWeProtect" style={{ color: "black" }}>
              <span>6. </span>HOW WE PROTECT YOUR INFORMATION
            </a>
            <br />

            <a href="#Retention" style={{ color: "black" }}>
              <span>7. </span>RETENTION
            </a>
            <br />

            <a href="#UserRigths" style={{ color: "black" }}>
              <span>8. </span>USER RIGHTS
            </a>
            <br />

            <a href="#Transfer" style={{ color: "black" }}>
              <span>9. </span>TRANSFER OF DATA OUTSIDE THE EEA
            </a>
            <br />

            <a href="#OurPolicy" style={{ color: "black" }}>
              <span>10. </span>OUR POLICY TOWARD CHILDREN
            </a>
            <br />

            <a href="#HowToContactUs" style={{ color: "black" }}>
              <span>11. </span>HOW TO CONTACT US?
            </a>
            <br />

            <a href="#Updates" style={{ color: "black" }}>
              <span>12. </span>UPDATES TO THIS POLICY
            </a>
            <br />
          </p>

          <h3 id="Grounds">
            <span>GROUNDS FOR DATA COLLECTION</span>
            <span>&nbsp;</span>
          </h3>
          <p>
            <span>
              Processing of your “<strong>Personal Data</strong>” (meaning any
              information which may potentially allow your identification,
              either directly or by using reasonable means) is necessary for the
              performance of our contractual obligations towards you, for
              providing you with our Services and the operation of our Website,
              to protect our legitimate interests and for compliance with legal
              and regulatory obligations to which we are subject.
            </span>
          </p>
          <p>
            <span>
              When you use our Services, you consent to the collection, storage,
              use, disclosure and other uses of your Personal Information as
              described in this Privacy Policy.
            </span>
          </p>

          <h3 id="WhatType">
            <span>WHAT TYPE OF DATA WE COLLECT?</span>
          </h3>
          <h3>
            <span>Personal Data</span>
          </h3>
          <p>
            <span>
              In the course of using the Services, we may collect certain
              Personal Data to provide and improve the Services, to contact or
              identify you, to enable you to access certain parts of the Service
            </span>
            <span>
              &nbsp;or as otherwise indicated in this Policy. We collect the
              following Personal Data about you
            </span>
            <span>:</span>
          </p>
          <ul style={{ listStyle: "disc", marginLeft: "0in" }}>
            <li>
              <span>When you send us an email&nbsp;</span>
              <span>
                or contact us through a contact form on the Website, we will
                collect your name and email address so we could respond to your
                inquiry. We may also collect any Personal Data that you choose
                to include in your inquiry to us.
              </span>
            </li>
            <li>
              <span>
                Our webserver may also automatically collect your IP address,
                and unique online identifiers. These details are pseudonymized
                (cannot directly identify you) and are collected for the purpose
                of delivering relevant content and operating and improving our
                Service.
              </span>
            </li>
          </ul>
          <h3>
            <span>Non-Personal Data</span>
          </h3>
          <p>
            <span>
              We also collect data about the use of our Service and the
              characteristics and activities of users, in order to operate it
              and improve it. We may collect the following non-Personal
              Data:&nbsp;
            </span>
            <span>
              Your operating system, device type, session start/stop time, time
              zone, network connection type (e.g., Wi-Fi, cellular), your
              general location (city and country), and general information
              regarding your browser and device.
            </span>
          </p>
          <p>
            <span>
              If we combine Personal Data with non-Personal Data, the combined
              data will be treated as Personal Data.&nbsp;
            </span>
          </p>

          <h3 id="HowDoWeUse">
            <span>HOW DO WE USE THE DATA WE COLLECT?</span>
          </h3>
          <ul>
            <li>
              <strong>
                <span>Provision of the Service</span>
              </strong>
              <em>
                <span>&nbsp;–&nbsp;</span>
              </em>
              <span>
                we will use the Personal Data you provide us for the provision
                and improvement of our Service, providing customer support and
                to respond to your queries.&nbsp;
              </span>
            </li>
            <li>
              <strong>
                <span>Service announcements</span>
              </strong>
              <span>
                &nbsp;- we will use your Personal Data to communicate with you
                and to keep you informed of our latest updates to our Service
                and offer you service offers.
              </span>
            </li>
            <li>
              <strong>
                <span>Analytics, surveys and research</span>
              </strong>
              <span>
                &nbsp;- from time to time, we may conduct surveys or test
                features, and analyze the data we have to develop, evaluate and
                improve these features, all in order to improve our Services and
                offerings, and think of new and exciting features for our users.
              </span>
            </li>
            <li>
              <strong>
                <span>Protecting our interests</span>
              </strong>
              <em>
                <span>&nbsp;-&nbsp;</span>
              </em>
              <span>
                we may use your Personal Data when we believe it’s necessary in
                order to take precautions against liabilities, investigate and
                defend ourselves against any third party claims or allegations,
                investigate and protect ourselves from fraud, protect the
                security or integrity of our services and protect the rights and
                property of the Ministry, its users and/or partners.&nbsp;
              </span>
            </li>
            <li>
              <strong>
                <span>Enforcing of policies</span>
              </strong>
              <span>
                &nbsp;- we may use your Personal Data in order to enforce our
                policies, including but not limited to our{" "}
                <a
                  href="https://goisrael.com/Posts/telaviv/Privacy_Policy"
                  style={{ textDecoration: "underline", color: "black" }}
                  target="_blank"
                >
                  {" "}
                  Terms{" "}
                </a>
              </span>
              <span style={{ lineHeight: "115%", fontSize: "8pt" }}></span>
              <span>.&nbsp;</span>
            </li>
            <li>
              <strong>
                <span>Compliance with legal and regulatory requirements</span>
              </strong>
              <span>
                &nbsp;- we may use your Personal Data to investigate violations,
                and as required by law, regulation or other governmental
                authority, or to comply with a subpoena or similar legal
                process.
              </span>
            </li>
            <li>
              <strong>
                <span>Newsletter</span>
              </strong>
              <span>
                &nbsp;- we may use your Personal Data in order to send you our
                newsletter, if you subscribed to it. &nbsp;
              </span>
              <ol style={{ listStyle: "circle" }}>
                <li>
                  <u>
                    <span>Opt-out of receiving our newsletter</span>
                  </u>
                  <span>
                    &nbsp;- You may choose not to receive our newsletter by
                    clicking on the “unsubscribe” link contained therein. Please
                    note that even if you unsubscribe, we may continue to send
                    you Service-related updates and notifications, or reply to
                    your queries and feedback you provide us.&nbsp;
                  </span>
                </li>
              </ol>
            </li>
          </ul>

          <h3 id="Tracking">
            <span>TRACKING TECHNOLOGIES</span>
          </h3>
          <p>
            <span>
              When you visit or access our Services we use (and authorize 3
              <sup>rd</sup> parties to use) pixels, cookies, events and other
              technologies (collectively, "
              <strong>Tracking Technologies</strong>"). Those allow us to
              automatically collect information about you, your device and your
              online behavior, in order to enhance your navigation in our
              Services, improve our Services’ performance, perform analytics and
              customize your experience. In addition, we may merge data we have
              with data collected through these tracking technologies and data
              we may obtain from other sources and, as a result, such data may
              become Personal Data.
            </span>
          </p>
          <p>
            If you do not accept the use of cookies by us, please disable
            cookies by following the instructions below. However, please note
            that disabling cookies might seriously affect the function, User
            experience and other features of our Services.
          </p>
          <h3>Types of Tracking Technologies We Use</h3>
          <p>
            There are two broad categories of cookies: (a){" "}
            <strong>First party cookies</strong>, served directly by us to your
            computer or mobile device, and (b){" "}
            <strong>Third party cookies</strong>, served by a third party. We
            use third party cookies for functionality, performance and
            analytics, and social media purposes.
          </p>
          <p>
            Cookies can remain on your computer or mobile device for different
            periods of time. Some cookies are "session cookies" and expires upon
            closing of your browser. Other cookies are "persistent cookies",
            meaning that they survive after your browser is closed. They can be
            used by websites to recognize your computer when you open your
            browser and browse the Internet again.
          </p>
          <p>
            For example, we use a performance tracking technology tool called “
            <strong>Google Analytics</strong>” to collect information about the
            use of the Website. Google Analytics collects information such as
            how often users visit this site, what pages they visit when they do
            so, and what other sites they used prior to coming to this Site. We
            use the information we get from Google Analytics to maintain and
            improve the Site and our products. We do not combine the information
            collected through the use of Google Analytics with personally
            identifiable information. Google’s ability to use and share
            information collected by Google Analytics about your visits to this
            Site is restricted by the Google Analytics Terms of Service,
            available at
            <a
              href="//www.google.com/analytics/terms/us.html"
              target="_blank"
              style={{ textDecoration: "underline", color: "black" }}
            >
              www.google.com/analytics/
            </a>
            , and the Google Privacy Policy, available at
            <a
              href="//www.google.com/policies/privacy/"
              target="_blank"
              style={{ textDecoration: "underline", color: "black" }}
            >
              www.google.com/policies/
            </a>
            . You can opt-out of Google's collection of Personal Data through
            Google Analytics by downloading and installing the Google Analytics
            Opt-out Browser Add-on, available at
            <a
              href="https://tools.google.com/dlpage/gaoptout"
              target="_blank"
              style={{ textDecoration: "underline", color: "black" }}
            >
              tools.google.com/dlpage/gaoptout
            </a>
            .
          </p>
          <h3>
            <span>Interest-Based Advertising &amp; User Choice</span>
          </h3>
          <p>
            Through our Services, we may display advertisements that are
            tailored to you, for example ads or partner services that are based
            on your recent browsing behavior. In order to tailor advertisements
            and services in which you might be interested, we as well as certain
            third parties may use Tracking Technologies to display
            advertisements based on your visits to the Websites, to target
            advertisements to you for products and services in which you might
            be interested, and to measure the effectiveness of the ads. You can
            turn off certain third party Tracking Technologies used for
            behavioral advertising purposes by visiting the Network Advertising
            Initiative&nbsp;or by visiting the&nbsp;DAA opt-out program&nbsp;or
            the&nbsp;EDAA consumer choice page&nbsp;(if you reside in the EU)
            using the links provided below. Please note that certain Tracking
            Technologies operate at the device and browser level, so to fully
            opt-out across devices, you will need to do so on each device and
            browser individually, as described below as well.
          </p>
          <h3>
            <span>How to Manage Your Tracking Technologies Settings</span>
          </h3>
          <p>
            There are various ways in which you can manage and control your
            Tracking Technologies settings. Please remember that, by deleting or
            blocking Tracking Technologies, some of the features of the Services
            may not work properly or as effectively.
          </p>
          <p style={{ marginBottom: "6.0pt" }}>
            <strong>
              Turning off cookies via your web browser
              <br />
              &nbsp;
            </strong>
            Most web browsers will provide you with some general information
            about cookies, enable you to see what cookies are stored on your
            device, allow you to delete them all or on an individual basis, and
            enable you to block or allow cookies for all websites or
            individually selected websites. You can also normally turn off third
            party cookies separately. Please note that the settings offered by a
            browser or device often only apply to that particular browser or
            device. Information about cookies is usually found in the "Help"
            section of the web browser. Below are some links to some commonly
            used web browsers:
          </p>
          <p>
            <a
              href="https://support.google.com/chrome/answer/95647?hl=en"
              target="_blank"
              style={{ textDecoration: "underline", color: "black" }}
            >
              <span>Google Chrome</span>
            </a>
            <br />

            <a
              href="https://support.microsoft.com/en-us/kb/260971"
              target="_blank"
              style={{ textDecoration: "underline", color: "black" }}
            >
              <span>Internet Explorer</span>
            </a>
            <br />

            <a
              href="https://support.mozilla.org/en-US/kb/cookies-information-websites-store-on-your-computer"
              target="_blank"
              style={{ textDecoration: "underline", color: "black" }}
            >
              <span>Mozilla Firefox</span>
            </a>
            <br />

            <a
              href="https://support.apple.com/kb/PH5042?locale=en_US"
              target="_blank"
              style={{ textDecoration: "underline", color: "black" }}
            >
              <span>Safari (Desktop)</span>
            </a>
            <br />

            <a
              href="https://support.apple.com/en-us/HT201265"
              target="_blank"
              style={{ textDecoration: "underline", color: "black" }}
            >
              <span>Safari (Mobile)</span>
            </a>
            <br />

            <a
              href="//support.google.com/ics/nexus/bin/answer.py?hl=en&amp;answer=2425067"
              target="_blank"
              style={{ textDecoration: "underline", color: "black" }}
            >
              <span>Android Browser</span>
            </a>
            <br />

            <a
              href="//www.opera.com/help"
              target="_blank"
              style={{ textDecoration: "underline", color: "black" }}
            >
              <span>Opera</span>
            </a>
            <br />

            <a
              href="//www.opera.com/help/mobile/android#privacy"
              target="_blank"
              style={{ textDecoration: "underline", color: "black" }}
            >
              <span>Opera Mobile</span>
            </a>
          </p>
          <p>
            For other browsers, please consult the documentation that your
            browser manufacturer provides.
          </p>
          <p style={{ marginBottom: "6.0pt" }}>
            <strong>
              Turning off third party cookies
              <br />
              &nbsp;
            </strong>
            You can turn off certain third party targeting/advertising cookies
            by visiting the following link:&nbsp;
            <a
              href="//www.networkadvertising.org/choices/"
              target="_blank"
              style={{ textDecoration: "underline", color: "black" }}
            >
              Network Advertising Initiative
            </a>
            .
          </p>
          <h3>
            <span>Other helpful resources</span>
            <br />
          </h3>
          <p>
            <span>
              To learn more about advertisers’ use of cookies the following
              links may be helpful:
            </span>
            <br />
            <a
              href="//www.youronlinechoices.eu/"
              target="_blank"
              style={{ textDecoration: "underline", color: "black" }}
            >
              <span>
                European Interactive Digital Advertising Alliance (EU)
              </span>
            </a>
            <br />

            <a
              href="//www.iab.net/"
              target="_blank"
              style={{ textDecoration: "underline", color: "black" }}
            >
              <span>Internet Advertising Bureau (US)</span>
            </a>
            <br />

            <a
              href="//www.iabeurope.eu/"
              target="_blank"
              style={{ textDecoration: "underline", color: "black" }}
            >
              <span>Internet Advertising Bureau (EU)</span>
            </a>
          </p>
          <p
            style={{
              marginTop: "6pt",
              marginRight: "0",
              marginBottom: ".0001pt",
              marginLeft: 0,
              textAlign: "justify",
            }}
          >
            <strong>Turning off cookies on a mobile device</strong>
          </p>
          <p>
            You can-opt out of certain types of interest-based advertising, by
            accessing the “settings” on your device:
          </p>
          <ul style={{ listStyle: "disc" }}>
            <li>
              <strong>
                <span>If you're using an Apple device</span>
              </strong>
              <span>
                &nbsp;you can configure your device to limit ad tracking to by
                clicking on "settings" &gt; "privacy" &gt; "advertising" and
                toggling "limit ad tracking" to ‘on.’
              </span>
            </li>
            <li>
              <strong>
                <span>If you're using an Android device</span>
              </strong>
              <span>
                &nbsp;you can opt out of most app-based tracking for advertising
                by opening the "Google Settings" app on your device, selecting
                "Ads", and then selecting the option to opt-out of
                interest-based ads.
              </span>
            </li>
          </ul>
          <p>
            Please note that the above information may change when manufacturers
            update their systems. Also note, that your device may use another
            platform, not described above. In that case, please consult the
            manufacturer documentation for further instructions.
          </p>

          <h3 id="WitWhom">
            <span>WITH WHOM DO WE SHARE YOUR PERSONAL DATA?</span>
          </h3>
          <ul>
            <li>
              <strong>
                <span>Internal concerned parties</span>
              </strong>
              <span>&nbsp;- we may share your information with other</span>
              <span>&nbsp;</span>
              <span>
                government ministries, as well as our employees, as needed to
                provide our Services.
              </span>
            </li>
            <li>
              <strong>
                <span>Business partners</span>
              </strong>
              <span>
                &nbsp;- we may share your information with business partners
                such as storage and analytics providers who help us provide you
                with our Services. These third parties may have access to your
                Personal Data so that they may perform these tasks on our
                behalf, but they are obligated to comply with the highest
                security standards and applicable data protection legislation,
                and may not use your Personal Data for any other purpose.
              </span>
            </li>
            <li>
              <strong>
                <span>Compliance with laws and law enforcement entities</span>
              </strong>
              <span>
                &nbsp;- we cooperate with other governmental agencies and law
                enforcement officials to enforce and comply with the law. We
                will disclose Personal Data about you to government or law
                enforcement officials or private parties if we, in our sole
                discretion, believe necessary or appropriate to respond to
                claims and legal process (including but not limited to
                subpoenas), to protect our or a third party's property and
                rights, to protect the safety of the public or any person, or to
                prevent or stop any activity we may consider to be, or to pose a
                risk of being, illegal, unethical, inappropriate or legally
                actionable.&nbsp;
              </span>
            </li>
          </ul>

          <h3 id="HowWeProtect">
            <span>HOW WE PROTECT YOUR INFORMATION</span>
          </h3>
          <p>
            <span>
              We have implemented administrative, technical, and physical
              safeguards to help prevent unauthorized access, use, or disclosure
              of your Personal Data. Your data is stored on secure servers and
              isn’t publicly available. We limit access of your information only
              to those employees or partners on a “need to know” basis, in order
              to enable the carrying out of the agreement between us.&nbsp;
            </span>
          </p>
          <p>
            <span>
              While we seek to protect your information to ensure that it is
              kept confidential, we cannot absolutely guarantee its security.
              You should be aware that there is always some risk involved in
              transmitting information over the internet. While we strive to
              protect your Personal Data, we cannot ensure or warrant the
              security and privacy of your Personal Data or other content you
              transmit using the Service, and you do so at your own risk.&nbsp;
            </span>
          </p>

          <h3 id="Retention">
            <span>RETENTION</span>
          </h3>
          <p>
            <span>
              We will retain your Personal Data for as long as necessary to
              provide our Services, and as necessary to comply with our legal
              obligations, resolve disputes, and enforce our policies. Retention
              periods will be determined taking into account the type of
              information that is collected and the purpose for which it is
              collected, bearing in mind the requirements applicable to the
              situation and the need to destroy outdated, unused information at
              the earliest reasonable time. Under applicable regulations, we
              will keep records containing Personal Data, communications and
              anything else as required by applicable laws and
              regulations.&nbsp;
            </span>
          </p>

          <h3 id="UserRigths">
            <span>USER RIGHTS</span>
          </h3>
          <h4>
            <strong>
              <span>EU User Rights</span>
            </strong>
          </h4>
          <p>
            <span>As an EU resident, you may request to:&nbsp;</span>
          </p>
          <ol
            start="1"
            style={{ listStyleType: "lower-alpha", marginLeft: "0" }}
          >
            <li>
              <span>
                Receive confirmation as to whether or not Personal Data
                concerning you is being processed, and access your stored
                Personal Data, together with supplementary information.&nbsp;
              </span>
            </li>
            <li>
              <span>
                Receive a copy of Personal Data you directly volunteer to us in
                a structured, commonly used and machine-readable format.&nbsp;
              </span>
            </li>
            <li>
              <span>
                Request rectification of your Personal Data that is in our
                control.
              </span>
            </li>
            <li>
              <span>Request erasure of your Personal Data.&nbsp;</span>
            </li>
            <li>
              <span>
                Object to the processing of Personal Data by us.&nbsp;
              </span>
            </li>
            <li>
              <span>
                Request to restrict processing of your Personal Data by us.
              </span>
            </li>
            <li>
              <span>Lodge a complaint with a supervisory authority.</span>
            </li>
          </ol>
          <p>
            <span>
              Please note that these rights pertain to EU residents only, are
              not absolute, and may be subject to our own legitimate interests
              and regulatory requirements.&nbsp;
            </span>
          </p>
          <p>
            <span>Users Outside the EU -&nbsp;</span>
            <span>
              Some of the aforementioned rights are applicable in certain
              jurisdictions outside the EU as well. Users residing outside the
              EU are welcome to contact us for any questions or requests by
              using the details provided below.
            </span>
          </p>

          <h3 id="Transfer">
            <span>TRANSFER OF DATA OUTSIDE THE EEA</span>
            <span>&nbsp;</span>
          </h3>
          <p>
            <span>
              If you reside in the European Union ("<strong>EU</strong>"),
              please note that some data recipients may be located outside the
              EEA. In such cases we will transfer your data only to such
              countries as approved by the European Commission as providing
              adequate level of data protection, or enter into legal agreements
              ensuring an adequate level of data protection.
            </span>
          </p>

          <h3 id="OurPolicy">
            <span>OUR POLICY TOWARD CHILDREN</span>
          </h3>
          <p>
            We do not knowingly collect or solicit personal information from
            anyone under 18 years of age, (or the age of consent as determined
            under the applicable laws where the individual resides; “
            <strong>Age of Consent</strong>”). By accessing, using or
            interacting with our Services, you certify to us that you are not
            under the Age of Consent. In the event that we learn that we have
            collected personal information from an individual under the Age of
            Consent without verification of parental consent, we will delete
            that information upon discovery. If you believe that we might have
            any information from or about an individual under the Age of
            Consent, then please contact us through the contact details
            available below.
          </p>

          <h3 id="HowToContactUs">
            <span>HOW TO CONTACT US?</span>
          </h3>
          <p>
            <span>
              If you wish to exercise any of the aforementioned rights, or
              receive more information, please contact us using the details
              below:
            </span>
            <br />
            Email:
            <a
              href="mailto:Dpo@tourism.gov.il"
              style={{ textDecoration: "underline", color: "black" }}
            >
              {" "}
              Dpo@tourism.gov.il
            </a>
          </p>

          <h3 id="Updates">
            <span>UPDATES TO THIS POLICY</span>
          </h3>
          <p>
            This Privacy Policy is subject to changes from time to time, in our
            sole discretion. The most current version will always be posted on
            our Services (as reflected in the "Last Updated" heading). You are
            advised to check for updates regularly. By continuing to access or
            use our Services after any revisions become effective, you agree to
            be bound by the updated Privacy Policy.&nbsp;
          </p>
        </div>

        <Footer />
      </div>
    );
  }
}

export default PrivacyPolicy;



// WEBPACK FOOTER //
// ./src/Pages/PrivacyPolicy/PrivacyPolicy.js